import React from 'react';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { MdCancel } from "react-icons/md";
import { getParams,nNU } from 'util/utils';
import { useEffect } from 'react';
import sendRequest from 'util/request';
import Urls from 'util/urls';
import Paths from 'util/paths';
import { BsCheckCircleFill } from "react-icons/bs";
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useCallback } from 'react';
import { sendPost } from 'util/request';
import './PcSuccessNotify.scss';

const SuccessNotify = ({ data = { orderId: null } }) => {
    const params = getParams();
    const orderId = data.orderId || params?.orderId || params?.id;
    const [selectedOrderId, setSelectedOrderId] = useState(orderId);
    // const [order, setOrder]=useState(null)
    const [showForm, setShowForm] = useState(false);
    const history = useHistory();
    const handleBack = () => {
        // history.goBack();
				history.push(Paths.servicecode.servicecode);
    };
    useEffect(()=>{
        if (!nNU(selectedOrderId)) {
            history.push(Paths.notifyfincode.error);
        }
        sendRequest({
            url: `${Urls.fincode.order}/${selectedOrderId}`,
            method: 'GET',
        }).then((response) => {
            const { result } = response;
            if (!nNU(result)) {
                history.push(Paths.notifyfincode.error);
            } else {
                if (!nNU(result?.status)) {
                    history.push(Paths.notifyfincode.error);
                } else if (result?.status === '注文キャンセル') {
                    history.push(`${Paths.notifyfincode.cancel}/?id=${selectedOrderId}`);
                } else {
                    setShowForm(true);
                }
            }
            // setOrder(result);
        }).catch((e) => {
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOrderId]);

    return (!!showForm && (
        <div className="success-notification">
            <BsCheckCircleFill className='success-icon' />
            <p>お支払いが完了しました。</p>
            <p>ブラウザを閉じて終了してください</p>
            <Button onClick={handleBack}>戻る</Button>
        </div>
    )
    );
};
export default SuccessNotify;
